import { UPDATE_USER_ID } from '../../actions/cm/context';

export const initialState = {
  userId: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case UPDATE_USER_ID:
      return {
        ...state,
        userId: payload
      };
    default:
      return state;
  }
}
